import { createScreenText } from 'helpers/screenText';
const st = createScreenText('ticket_type_management');

// src/pages/TicketTypeManagement/types.ts
// TypeScript type definitions cho Quản lý Loại Vé

// Khớp với TicketTypeDto từ backend
export interface TicketType {
  id: number;
  code: string;
  name: string;
  digits: number;
  drawRounds: number;
  quantityPerPeriod: number;
  displayOrder: number;
  isLocked: boolean;
  createdAt?: string;
  lastModifiedAt?: string;
}

// DTO cho việc tạo mới loại vé
export interface CreateTicketTypeDto {
  code?: string;
  name: string;
  digits: number;
  drawRounds: number;
  quantityPerPeriod: number;
  displayOrder: number;
}

// DTO cho việc cập nhật loại vé (Code bất biến sau khi tạo)
export interface UpdateTicketTypeDto {
  id: number;
  name: string;
  digits: number;
  drawRounds: number;
  quantityPerPeriod: number;
  displayOrder: number;
}

// Filter parameters cho việc search
export interface TicketTypeFilters {
  searchTerm: string;
  isLocked: 'All' | 'false' | 'true';
}

// Pagination info
export interface TicketTypePagination {
  currentPage: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

// Modal states
export interface TicketTypeModalState {
  create: boolean;
  edit: boolean;
}

export const LOCK_STATUS_OPTIONS = [
  { value: 'All', label: st('tat_ca_label') },
  { value: 'false', label: st('dang_mo_text') },
  { value: 'true', label: st('da_khoa_text') },
];
